import { Injectable } from '@angular/core';

import {
  IMandrillEmailMessageTemplate,
  IMandrillEmailPreviewRequestModel
} from 'src/app/shared/models/mandrillEmailTemplate';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class MandrillEmailTemplateService extends BaseService {
  private basePath = 'templates';

  constructor() {
    super();
  }

  getPreviewContent(template: IMandrillEmailMessageTemplate) {
    let body: IMandrillEmailPreviewRequestModel = {
      templateName: template.name,
      mergeVars: template.mergeVars
    };

    let payload = JSON.stringify(body);
    return this.post(`${this.basePath}/render`, payload);
  }
}
